import { useMemo } from 'react';
import useCheckoutState from './useCheckoutState';
import { selectablePrices, resolveSelectedPrice } from '../lib/multiPrice';

/**
 * Resolve the buyer's currently selected price object for a multi-price product:
 *   selectedPriceId → (lone price if only one) → product.defaultPriceId → null.
 *
 * Returns `null` when a multi-price product has no selection and no explicit
 * default (the customer must make a pricing decision), and for legacy products
 * with no `prices[]` array (callers fall back to the legacy `product.*` fields).
 */
export default function useSelectedPrice() {
  const { product, selectedPriceId, query } = useCheckoutState();

  return useMemo(() => {
    const prices = product?.prices;
    if (!prices || prices.length === 0) return null;
    return resolveSelectedPrice(selectablePrices(prices, query), selectedPriceId, null);
  }, [product, selectedPriceId, query]);
}
